module.exports = __webpack_public_path__ + "static/media/phone.f0c9b72.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Nails/phone.mp4
// module id = jlqC
// module chunks = 1